(function() { module.exports = window["Bernie_l10nBundle_it_IT"]; }());